import * as React from 'react'

function SvgList({ color = '#001335', ...props }) {
  return (
    <svg width={24} height={24} fill="none" {...props}>
      <rect x={3} y={7} width={18} height={3} rx={0} fill={color} />
      <rect x={3} y={12} width={18} height={3} rx={1} fill={color} />
      <rect x={3} y={17} width={18} height={3} rx={1} fill={color} />
    </svg>
  )
}

export default SvgList
